export default class APIApplication {
  constructor(API) {
    this.api = API;
  }

  async start(userID, certID, applicationType) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/user/${userID}/certification/${certID}/application/${applicationType}`;
    return await req.exec();
  }

  async submitPreApproval(userID, certProcID, applicationType) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/user/${userID}/certification/${certProcID}/application/${applicationType}/preApproval`;
    return await req.exec();
  }

  async submit(userID, certProcID, applicationType, activationKey) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/user/${userID}/certification/${certProcID}/application/${applicationType}/submit`;
    req.body = { ...(activationKey ? { activationKey } : {}) };
    return await req.exec();
  }

  async getForeignItems(userID, certProcID, applicationType) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/user/${userID}/certification/${certProcID}/application/${applicationType}/foreignFill`;
    return await req.exec();
  }

  async acknowledge(userID, certProcID, applicationType) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/user/${userID}/certification/${certProcID}/application/${applicationType}/acknowledge`;
    return await req.exec();
  }

  async getApplicationsReport(from, to, tenantID, certificationID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/tenant/report/applicationExport';
    req.appendQueryParam('from', from);
    req.appendQueryParam('to', to);
    req.appendQueryParam('tenantID', tenantID);
    req.appendQueryParam('certificationID', certificationID);
    req.bodyType = 'JSON/BLOB';
    return await req.exec();
  }

  async getApplicationsStatusReport(certificationID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/tenant/report/applicationStatus';
    req.body = { certificationID };
    return await req.exec();
  }
}
